import React from 'react';
import { SimpleGrid, Skeleton, Box } from '@chakra-ui/react';

import ProductCard from './ProductCard';
import Reveal from '../layout/Reveal';

// Product grids (design-system.md §2.3). `home`: 4 columns / 7px gap, 2 on phones.
// `collection`: 3 columns beside the filter rail (16px rows, 8px columns), 2 on phones.
const LAYOUT = {
    home: { columns: { base: 2, lg: 4 }, spacingX: { base: '8px', lg: '7px' }, spacingY: { base: '20px', lg: '28px' }, price: 'small' },
    collection: { columns: { base: 2, lg: 3 }, spacingX: '8px', spacingY: { base: '20px', lg: '24px' }, price: 'large' },
};

const ProductGrid = ({ products, variant = 'home', loading = false, skeletons = 8 }) => {
    const l = LAYOUT[variant];
    return (
        <SimpleGrid columns={l.columns} spacingX={l.spacingX} spacingY={l.spacingY} >
            {loading
                ? Array.from({ length: skeletons }).map((_, i) => (
                    <Box key={i} >
                        <Skeleton sx={{ aspectRatio: '2 / 3' }} />
                        <Skeleton height='14px' mt='10px' width='80%' />
                        <Skeleton height='14px' mt='6px' width='30%' />
                    </Box>
                ))
                : products.map((p, i) => <Reveal key={p._id} delay={(i % 4) * 60} ><ProductCard product={p} priceSize={l.price} /></Reveal>)}
        </SimpleGrid>
    );
};

export default ProductGrid;
